// Roland Garros 2026 - Base de données de référence COMPLÈTE
// Utilisé pour l'import intelligent et la normalisation automatique

export const ROLAND_GARROS_2026 = {
  // Informations générales
  tournament: {
    name: 'ROLAND GARROS 2026',
    shortName: 'RG',
    venue: 'Stade Roland Garros',
    city: 'Paris',
    country: 'France',
    startDate: '2026-05-24',
    endDate: '2026-06-07',
  },

  // Courts avec leurs alias pour la normalisation
  courts: {
    'PHILIPPE CHATRIER': {
      normalized: 'Court Philippe-Chatrier',
      aliases: [
        'PHILIPPE CHATRIER', 'CHATRIER', 'PC', 'PHILIPPE-CHATRIER',
        'RG PHILIPPE CHATRIER', 'RG PHILIPPE-CHATRIER', 'COURT PHILIPPE CHATRIER',
        'COURT PHILIPPE-CHATRIER', 'CENTRAL', 'COURT CENTRAL'
      ],
    },
    'SUZANNE LENGLEN': {
      normalized: 'Court Suzanne Lenglen',
      aliases: [
        'SUZANNE LENGLEN', 'LENGLEN', 'SL', 'SUZANNE-LENGLEN',
        'RG SUZANNE LENGLEN', 'RG SUZANNE-LENGLEN', 'COURT SUZANNE LENGLEN',
        'COURT SUZANNE-LENGLEN'
      ],
    },
    'SIMONNE MATHIEU': {
      normalized: 'Court Simonne Mathieu',
      aliases: [
        'SIMONNE MATHIEU', 'MATHIEU', 'SM', 'SIMONNE-MATHIEU',
        'RG SIMONNE MATHIEU', 'RG SIMONNE-MATHIEU', 'COURT SIMONNE MATHIEU',
        'COURT SIMONNE-MATHIEU'
      ],
    },
    'OUTSIDE COURTS': {
      normalized: 'Outside Courts',
      aliases: [
        'OUTSIDE COURTS', 'OUTSIDE', 'ANNEXES', 'COURTS ANNEXES',
        'AUTRES COURTS', 'OTHER COURTS'
      ],
    },
  },

  // Catégories avec leurs alias pour la normalisation
  categories: {
    'GOLD': { 
      normalized: 'GOLD', 
      aliases: ['GOLD', 'OR', 'CAT OR', 'CAT. OR', 'CATEGORIE OR', 'CATEGORY OR', 'CAT GOLD'] 
    },
    'CATEGORIE 1': { 
      normalized: 'CATEGORIE 1', 
      aliases: ['1', 'CAT 1', 'CAT. 1', 'CATEGORIE 1', 'CATEGORY 1', 'CAT1', 'CATÉGORIE 1'] 
    },
    'CATEGORIE 2': { 
      normalized: 'CATEGORIE 2', 
      aliases: ['2', 'CAT 2', 'CAT. 2', 'CATEGORIE 2', 'CATEGORY 2', 'CAT2', 'CATÉGORIE 2'] 
    },
    'CATEGORIE 3': { 
      normalized: 'CATEGORIE 3', 
      aliases: ['3', 'CAT 3', 'CAT. 3', 'CATEGORIE 3', 'CATEGORY 3', 'CAT3', 'CATÉGORIE 3'] 
    },
  },

  // Sessions (Jour/Nuit)
  sessions: {
    'DAY': { 
      normalized: 'Day Session', 
      aliases: ['DAY', 'JOUR', 'JOURNEE', 'JOURNÉE', 'J', 'DAY SESSION', 'MATIN', 'APRES-MIDI'] 
    },
    'NIGHT': { 
      normalized: 'Evening Session', 
      aliases: ['NIGHT', 'NUIT', 'SOIREE', 'SOIRÉE', 'SOIR', 'N', 'EVENING', 'EVENING SESSION'] 
    },
  },

  // Rounds avec leurs alias pour la normalisation
  rounds: {
    '1R': { normalized: '1st Round', aliases: ['1ST ROUND', '1ER TOUR', 'R1', '1R'] },
    '2R': { normalized: '2nd Round', aliases: ['2ND ROUND', '2EME TOUR', 'R2', '2R'] },
    '3R': { normalized: '3rd Round', aliases: ['3RD ROUND', '3EME TOUR', 'R3', '3R'] },
    '4R': { normalized: '4th Round', aliases: ['4TH ROUND', '4EME TOUR', 'R4', '4R', '8EME'] },
    'QF': { normalized: 'Quarterfinal', aliases: ['QUARTERFINAL', 'QUART', 'QUARTER', '1/4', 'QF'] },
    'SF': { normalized: 'Semifinal', aliases: ['SEMIFINAL', 'SEMI', 'DEMI', '1/2', 'SF'] },
    'F': { normalized: 'Final', aliases: ['FINAL', 'FINALE', 'F'] },
  },

  // Programme complet officiel Roland Garros 2026
  schedule: [
    // Day 1 - Sunday 24 May 2026 - 1st Round
    { day: 1, date: '2026-05-24', dayOfWeek: 'Sunday', round: '1st Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 1, date: '2026-05-24', dayOfWeek: 'Sunday', round: '1st Round', session: null, court: 'Outside Courts' },
    { day: 1, date: '2026-05-24', dayOfWeek: 'Sunday', round: '1st Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 1, date: '2026-05-24', dayOfWeek: 'Sunday', round: '1st Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 2 - Monday 25 May 2026 - 1st Round
    { day: 2, date: '2026-05-25', dayOfWeek: 'Monday', round: '1st Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 2, date: '2026-05-25', dayOfWeek: 'Monday', round: '1st Round', session: null, court: 'Outside Courts' },
    { day: 2, date: '2026-05-25', dayOfWeek: 'Monday', round: '1st Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 2, date: '2026-05-25', dayOfWeek: 'Monday', round: '1st Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 3 - Tuesday 26 May 2026 - 1st Round
    { day: 3, date: '2026-05-26', dayOfWeek: 'Tuesday', round: '1st Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 3, date: '2026-05-26', dayOfWeek: 'Tuesday', round: '1st Round', session: null, court: 'Outside Courts' },
    { day: 3, date: '2026-05-26', dayOfWeek: 'Tuesday', round: '1st Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 3, date: '2026-05-26', dayOfWeek: 'Tuesday', round: '1st Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 4 - Wednesday 27 May 2026 - 2nd Round
    { day: 4, date: '2026-05-27', dayOfWeek: 'Wednesday', round: '2nd Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 4, date: '2026-05-27', dayOfWeek: 'Wednesday', round: '2nd Round', session: null, court: 'Outside Courts' },
    { day: 4, date: '2026-05-27', dayOfWeek: 'Wednesday', round: '2nd Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 4, date: '2026-05-27', dayOfWeek: 'Wednesday', round: '2nd Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 5 - Thursday 28 May 2026 - 2nd Round
    { day: 5, date: '2026-05-28', dayOfWeek: 'Thursday', round: '2nd Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 5, date: '2026-05-28', dayOfWeek: 'Thursday', round: '2nd Round', session: null, court: 'Outside Courts' },
    { day: 5, date: '2026-05-28', dayOfWeek: 'Thursday', round: '2nd Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 5, date: '2026-05-28', dayOfWeek: 'Thursday', round: '2nd Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 6 - Friday 29 May 2026 - 3rd Round
    { day: 6, date: '2026-05-29', dayOfWeek: 'Friday', round: '3rd Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 6, date: '2026-05-29', dayOfWeek: 'Friday', round: '3rd Round', session: null, court: 'Outside Courts' },
    { day: 6, date: '2026-05-29', dayOfWeek: 'Friday', round: '3rd Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 6, date: '2026-05-29', dayOfWeek: 'Friday', round: '3rd Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 7 - Saturday 30 May 2026 - 3rd Round
    { day: 7, date: '2026-05-30', dayOfWeek: 'Saturday', round: '3rd Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 7, date: '2026-05-30', dayOfWeek: 'Saturday', round: '3rd Round', session: null, court: 'Outside Courts' },
    { day: 7, date: '2026-05-30', dayOfWeek: 'Saturday', round: '3rd Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 7, date: '2026-05-30', dayOfWeek: 'Saturday', round: '3rd Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 8 - Sunday 31 May 2026 - 4th Round
    { day: 8, date: '2026-05-31', dayOfWeek: 'Sunday', round: '4th Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 8, date: '2026-05-31', dayOfWeek: 'Sunday', round: '4th Round', session: null, court: 'Outside Courts' },
    { day: 8, date: '2026-05-31', dayOfWeek: 'Sunday', round: '4th Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 8, date: '2026-05-31', dayOfWeek: 'Sunday', round: '4th Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 9 - Monday 1 June 2026 - 4th Round
    { day: 9, date: '2026-06-01', dayOfWeek: 'Monday', round: '4th Round', session: null, court: 'Court Suzanne Lenglen' },
    { day: 9, date: '2026-06-01', dayOfWeek: 'Monday', round: '4th Round', session: null, court: 'Outside Courts' },
    { day: 9, date: '2026-06-01', dayOfWeek: 'Monday', round: '4th Round', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 9, date: '2026-06-01', dayOfWeek: 'Monday', round: '4th Round', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 10 - Tuesday 2 June 2026 - Quarterfinals
    { day: 10, date: '2026-06-02', dayOfWeek: 'Tuesday', round: 'Quarterfinals', session: null, court: 'Outside Courts' },
    { day: 10, date: '2026-06-02', dayOfWeek: 'Tuesday', round: 'Quarterfinal #1', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 10, date: '2026-06-02', dayOfWeek: 'Tuesday', round: 'Quarterfinal #2', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 11 - Wednesday 3 June 2026 - Quarterfinals
    { day: 11, date: '2026-06-03', dayOfWeek: 'Wednesday', round: 'Quarterfinal #3', session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 11, date: '2026-06-03', dayOfWeek: 'Wednesday', round: 'Quarterfinal #4', session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    { day: 11, date: '2026-06-03', dayOfWeek: 'Wednesday', round: 'Quarterfinals', session: null, court: 'Outside Courts' },
    
    // Day 12 - Thursday 4 June 2026 - Women's Semifinals
    { day: 12, date: '2026-06-04', dayOfWeek: 'Thursday', round: "Women's Semifinals", session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 12, date: '2026-06-04', dayOfWeek: 'Thursday', round: "Women's Semifinals", session: null, court: 'Outside Courts' },
    
    // Day 13 - Friday 5 June 2026 - Men's Semifinals
    { day: 13, date: '2026-06-05', dayOfWeek: 'Friday', round: "Men's Semifinals", session: null, court: 'Outside Courts' },
    { day: 13, date: '2026-06-05', dayOfWeek: 'Friday', round: "Men's Semifinal #1", session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 13, date: '2026-06-05', dayOfWeek: 'Friday', round: "Men's Semifinal #2", session: 'Evening Session', court: 'Court Philippe-Chatrier' },
    
    // Day 14 - Saturday 6 June 2026 - Women's Final
    { day: 14, date: '2026-06-06', dayOfWeek: 'Saturday', round: "Women's Final", session: 'Day Session', court: 'Court Philippe-Chatrier' },
    { day: 14, date: '2026-06-06', dayOfWeek: 'Saturday', round: "Women's Final", session: null, court: 'Outside Courts' },
    
    // Day 15 - Sunday 7 June 2026 - Men's Final
    { day: 15, date: '2026-06-07', dayOfWeek: 'Sunday', round: "Men's Final", session: null, court: 'Outside Courts' },
    { day: 15, date: '2026-06-07', dayOfWeek: 'Sunday', round: "Men's Final", session: 'Day Session', court: 'Court Philippe-Chatrier' },
  ],

  // Mapping des noms d'événements depuis vos données vers le format normalisé
  eventMappings: {
    // Tours préliminaires par date (format: "XX MAI - DAY/NIGHT")
    '24 MAI - DAY': { date: '2026-05-24', round: '1st Round', session: 'Day Session' },
    '24 MAI - NIGHT': { date: '2026-05-24', round: '1st Round', session: 'Evening Session' },
    '25 MAI - DAY': { date: '2026-05-25', round: '1st Round', session: 'Day Session' },
    '25 MAI - NIGHT': { date: '2026-05-25', round: '1st Round', session: 'Evening Session' },
    '26 MAI - DAY': { date: '2026-05-26', round: '1st Round', session: 'Day Session' },
    '26 MAI - NIGHT': { date: '2026-05-26', round: '1st Round', session: 'Evening Session' },
    '27 MAI - DAY': { date: '2026-05-27', round: '2nd Round', session: 'Day Session' },
    '27 MAI - NIGHT': { date: '2026-05-27', round: '2nd Round', session: 'Evening Session' },
    '28 MAI - DAY': { date: '2026-05-28', round: '2nd Round', session: 'Day Session' },
    '28 MAI - NIGHT': { date: '2026-05-28', round: '2nd Round', session: 'Evening Session' },
    '29 MAI - DAY': { date: '2026-05-29', round: '3rd Round', session: 'Day Session' },
    '29 MAI - NIGHT': { date: '2026-05-29', round: '3rd Round', session: 'Evening Session' },
    '30 MAI - DAY': { date: '2026-05-30', round: '3rd Round', session: 'Day Session' },
    '30 MAI - NIGHT': { date: '2026-05-30', round: '3rd Round', session: 'Evening Session' },
    '31 MAI - DAY': { date: '2026-05-31', round: '4th Round', session: 'Day Session' },
    '31 MAI - NIGHT': { date: '2026-05-31', round: '4th Round', session: 'Evening Session' },
    '1 JUIN - DAY': { date: '2026-06-01', round: '4th Round', session: 'Day Session' },
    '1 JUIN - NIGHT': { date: '2026-06-01', round: '4th Round', session: 'Evening Session' },
    
    // Quarts de finale
    'QUARTER DE FINAL 1 DAY': { date: '2026-06-02', round: 'Quarterfinal #1', session: 'Day Session' },
    'QUARTER DE FINAL 2 NIGHT': { date: '2026-06-02', round: 'Quarterfinal #2', session: 'Evening Session' },
    'QUARTER DE FINAL 3 DAY': { date: '2026-06-03', round: 'Quarterfinal #3', session: 'Day Session' },
    'QUARTER DE FINAL 4 NIGHT': { date: '2026-06-03', round: 'Quarterfinal #4', session: 'Evening Session' },
    
    // Demi-finales
    'SEMI FINAL WOMEN': { date: '2026-06-04', round: "Women's Semifinals", session: 'Day Session' },
    'SEMI FINAL DAY MAN': { date: '2026-06-05', round: "Men's Semifinal #1", session: 'Day Session' },
    'SEMI FINAL NIGHT MAN': { date: '2026-06-05', round: "Men's Semifinal #2", session: 'Evening Session' },
    
    // Finales
    'FINAL WOMEN': { date: '2026-06-06', round: "Women's Final", session: 'Day Session' },
    'FINAL MAN': { date: '2026-06-07', round: "Men's Final", session: 'Day Session' },
  },
};

// ============================================
// FONCTIONS DE NORMALISATION
// ============================================

/**
 * Normalise un nom de court
 * @param {string} court - Le nom du court à normaliser
 * @returns {string} - Le nom normalisé ou l'original si non trouvé
 */
export const normalizeRGCourt = (court) => {
  if (!court) return '';
  const courtUpper = court.toUpperCase().trim();
  
  for (const [key, data] of Object.entries(ROLAND_GARROS_2026.courts)) {
    if (data.aliases.some(alias => courtUpper.includes(alias) || alias.includes(courtUpper))) {
      return data.normalized;
    }
  }
  return court;
};

/**
 * Normalise un nom de catégorie
 * @param {string} category - La catégorie à normaliser
 * @returns {string} - La catégorie normalisée
 */
export const normalizeRGCategory = (category) => {
  if (!category) return '';
  const cat = category.toUpperCase().trim();
  
  // Ordre de priorité: CATEGORIE 1, 2, 3 avant GOLD (pour éviter les faux positifs)
  const priorityOrder = ['CATEGORIE 1', 'CATEGORIE 2', 'CATEGORIE 3', 'GOLD'];
  
  for (const key of priorityOrder) {
    const data = ROLAND_GARROS_2026.categories[key];
    if (!data) continue;
    
    // Match exact d'abord
    if (data.aliases.some(alias => cat === alias)) {
      return data.normalized;
    }
  }
  
  // Si pas de match exact, chercher avec includes mais en évitant les faux positifs
  // Ne pas utiliser includes pour les chiffres seuls
  for (const key of priorityOrder) {
    const data = ROLAND_GARROS_2026.categories[key];
    if (!data) continue;
    
    for (const alias of data.aliases) {
      // Ignorer les alias qui sont juste un chiffre pour éviter les faux positifs
      if (/^\d$/.test(alias)) continue;
      
      if (cat.includes(alias) || alias.includes(cat)) {
        return data.normalized;
      }
    }
  }
  
  // Fallback: détecter les patterns courants
  const numMatch = cat.match(/(?:CATEGORY|CATEGORIE|CATÉGORIE|CAT\.?)\s*([1-3])/i);
  if (numMatch) {
    return `CATEGORIE ${numMatch[1]}`;
  }
  
  if (/\bGOLD\b|\bOR\b/i.test(cat)) {
    return 'GOLD';
  }
  
  return category.toUpperCase();
};

/**
 * Normalise une session (DAY/NIGHT)
 * @param {string} session - La session à normaliser
 * @returns {string} - La session normalisée
 */
export const normalizeRGSession = (session) => {
  if (!session) return '';
  const sess = session.toUpperCase().trim();
  
  for (const [key, data] of Object.entries(ROLAND_GARROS_2026.sessions)) {
    if (data.aliases.some(alias => sess === alias || sess.includes(alias))) {
      return data.normalized;
    }
  }
  return session;
};

/**
 * Trouve les informations d'un événement par son nom
 * @param {string} eventName - Le nom de l'événement
 * @returns {object|null} - Les informations de l'événement ou null
 */
export const findRGEvent = (eventName) => {
  if (!eventName) return null;
  
  // Nettoyer le nom (enlever "(RG)" etc.)
  const name = eventName.toUpperCase()
    .replace(/\(RG\)/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
  
  // Recherche exacte d'abord
  if (ROLAND_GARROS_2026.eventMappings[name]) {
    return { ...ROLAND_GARROS_2026.eventMappings[name], originalName: name };
  }
  
  // Recherche par inclusion
  for (const [key, data] of Object.entries(ROLAND_GARROS_2026.eventMappings)) {
    if (name.includes(key) || key.includes(name)) {
      return { ...data, originalName: key };
    }
  }
  
  return null;
};

/**
 * Normalise complètement un nom d'événement Roland Garros
 * Ex: "30 MAI - DAY (RG)" + "RG PHILIPPE CHATRIER" -> "Day 7 - 3rd Round - Day Session - Court Philippe-Chatrier"
 * @param {string} eventName - Le nom de l'événement (ex: "30 MAI - DAY (RG)")
 * @param {string} court - Le court (ex: "RG PHILIPPE CHATRIER")
 * @param {string} session - La session Day/Night (optionnel, extrait du nom si absent)
 * @returns {string} - Le nom normalisé
 */
export const normalizeRGEventName = (eventName, court = '', session = '') => {
  if (!eventName) return '';
  
  // Trouver les infos de l'événement
  const eventInfo = findRGEvent(eventName);
  
  if (!eventInfo) {
    // Pas trouvé dans le mapping, retourner le nom original nettoyé
    return eventName.replace(/\(RG\)/gi, '').trim();
  }
  
  // Trouver le numéro du jour
  const scheduleEntry = ROLAND_GARROS_2026.schedule.find(s => 
    s.date === eventInfo.date && 
    (eventInfo.session ? s.session === eventInfo.session : true)
  );
  
  const dayNum = scheduleEntry?.day || '';
  const round = eventInfo.round || '';
  const sess = eventInfo.session || normalizeRGSession(session) || '';
  const courtNorm = normalizeRGCourt(court) || '';
  
  // Construire le nom normalisé
  const parts = [];
  if (dayNum) parts.push(`Day ${dayNum}`);
  if (round) parts.push(round);
  if (sess) parts.push(sess);
  if (courtNorm) parts.push(courtNorm);
  
  return parts.join(' - ') || eventName;
};

/**
 * Génère un nom d'événement court pour l'affichage
 * Ex: "D7 - 3R - Day - Chatrier"
 * @param {string} eventName - Le nom de l'événement
 * @param {string} court - Le court
 * @param {string} session - La session
 * @returns {string} - Le nom court
 */
export const shortRGEventName = (eventName, court = '', session = '') => {
  if (!eventName) return '';
  
  const eventInfo = findRGEvent(eventName);
  if (!eventInfo) return eventName.replace(/\(RG\)/gi, '').trim();
  
  // Trouver le numéro du jour
  const scheduleEntry = ROLAND_GARROS_2026.schedule.find(s => 
    s.date === eventInfo.date && 
    (eventInfo.session ? s.session === eventInfo.session : true)
  );
  
  const dayNum = scheduleEntry?.day || '';
  const round = eventInfo.round || '';
  const sess = eventInfo.session || normalizeRGSession(session) || '';
  
  // Abréger le round
  const roundShort = round
    .replace('1st Round', '1R')
    .replace('2nd Round', '2R')
    .replace('3rd Round', '3R')
    .replace('4th Round', '4R')
    .replace('Quarterfinal', 'QF')
    .replace('Semifinal', 'SF')
    .replace('Final', 'F')
    .replace("Women's", 'W')
    .replace("Men's", 'M');
  
  // Abréger la session
  const sessShort = sess.includes('Day') ? 'Day' : sess.includes('Evening') ? 'Night' : '';
  
  // Abréger le court
  const courtNorm = normalizeRGCourt(court);
  const courtShort = courtNorm.includes('Chatrier') ? 'PC' : 
                     courtNorm.includes('Lenglen') ? 'SL' : 
                     courtNorm.includes('Mathieu') ? 'SM' : 
                     courtNorm.includes('Outside') ? 'Ext' : '';
  
  const parts = [];
  if (dayNum) parts.push(`D${dayNum}`);
  if (roundShort) parts.push(roundShort);
  if (sessShort) parts.push(sessShort);
  if (courtShort) parts.push(courtShort);
  
  return parts.join(' - ') || eventName;
};

/**
 * Parse une date au format français et retourne juste la date (sans heure)
 * @param {string} dateStr - La date au format "ven. 29/05/26 23:00" ou "29/05/26"
 * @returns {string} - La date au format "YYYY-MM-DD" ou vide
 */
export const parseRGDate = (dateStr) => {
  if (!dateStr) return '';
  
  // Format: "ven. 29/05/26 23:00" ou "29/05/26" ou "29/05/2026"
  const match = dateStr.match(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
  if (match) {
    const day = match[1].padStart(2, '0');
    const month = match[2].padStart(2, '0');
    let year = match[3];
    if (year.length === 2) year = '20' + year;
    
    return `${year}-${month}-${day}`;
  }
  
  return '';
};

/**
 * Normalise un prix (enlève €, espaces, convertit virgule en point)
 * @param {string} priceStr - Le prix au format "1,125€" ou "1125"
 * @returns {number} - Le prix en nombre
 */
export const parseRGPrice = (priceStr) => {
  if (!priceStr) return 0;
  
  // Enlever tout sauf chiffres, virgule et point
  const cleaned = priceStr.toString()
    .replace(/[€$£\s]/g, '')
    .replace(',', '.');
  
  const price = parseFloat(cleaned);
  return isNaN(price) ? 0 : price;
};

/**
 * Détecte automatiquement le type de colonne basé sur son contenu (pour Roland Garros)
 * @param {string[]} values - Les valeurs de la colonne
 * @param {string} headerName - Le nom de l'en-tête
 * @returns {string} - Le type de champ détecté
 */
export const detectRGColumnType = (values, headerName = '') => {
  const nonEmpty = values.filter(v => v && v.toString().trim());
  if (nonEmpty.length === 0) return 'ignore';
  
  const sample = nonEmpty[0].toString().trim();
  const header = headerName.toLowerCase().trim();
  
  // Détection par nom d'en-tête d'abord
  if (header === 'ref' || header === 'reference' || header === 'réf') return 'ref_vente';
  if (header === 'date vente' || header === 'date_vente') return 'date_operation';
  if (header === 'source') return 'source';
  if (header === 'evenement' || header === 'événement' || header === 'event') return 'evenement';
  if (header === 'jour/nuit' || header === 'day/night' || header === 'session') return 'session';
  if (header === 'cours' || header === 'court') return 'lieu';
  if (header === 'date evenement' || header === 'date événement' || header === 'date event') return 'date_evenement';
  if (header === 'categorie' || header === 'catégorie' || header === 'category' || header === 'cat') return 'categorie';
  if (header === 'qty' || header === 'quantite' || header === 'quantité') return 'qty';
  if (header === 'prix' || header === 'price') return 'prix';
  
  // Détection par contenu
  if (/^[A-Z0-9]+-\d+$/i.test(sample) || /^\d{6,}$/.test(sample)) return 'ref_vente';
  if (/CHATRIER|LENGLEN|MATHIEU|RG\s/i.test(sample)) return 'lieu';
  if (/FINAL|SEMI|QUARTER|MAI|JUIN|\(RG\)/i.test(sample)) return 'evenement';
  if (/^(DAY|NIGHT|JOUR|NUIT)$/i.test(sample.trim())) return 'session';
  if (/^(CAT|CATEGORY|CATEGORIE|GOLD)/i.test(sample)) return 'categorie';
  if (/[€$£]/.test(sample) || /^\d{1,6}[,.]?\d*$/.test(sample.replace(/\s/g, ''))) return 'prix';
  if (/^[1-9]$/.test(sample)) return 'qty';
  if (/\d{1,2}\/\d{1,2}\/\d{2,4}/.test(sample)) return 'date_evenement';
  
  return 'ignore';
};

export default ROLAND_GARROS_2026;
